module.exports = __webpack_public_path__ + "static/salesforce-a7f3f272a200b941bed3d73374a2d9eb.png";